import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
    providedIn: 'root'
})
export class VapiConfiguration {
    baseUrl: string = '';
    entrypoint: string = '';
    version: string = '';
}

/**
 * Parameters for `VapiModule.forRoot()`
 */
export interface VapiConfigurationParams {
    baseUrl?: string;
    entrypoint?: string;
    version?: string;
}
